import { resolveActionProperty } from './actionPropertyResolver.js';
import { serializeRuntimePropertyValue } from './propertyValueCodec.js';

export function serializeSetObjectPropertyAction(action, resolveTarget) {
    const pageId = Number(action?.target?.pageId);
    const objectId = Number(action?.target?.objectId);
    if (!Number.isInteger(pageId) || !Number.isInteger(objectId)) return null;
    const property = resolveActionProperty(resolveTarget?.(pageId, objectId), action.property);
    if (!property) return null;
    const value = serializeRuntimePropertyValue(action.value, property.metadata);
    if (value === null) return null;
    return `p${pageId}b${objectId}.${property.wireKey}=${value}`;
}
